<template>
<div class="view note" id="quick-note">
  <div>
    <ul class="toolbar">
      <li><a href="#" class="close-note-link"><i class="pg-arrow_left"></i></a>
      </li>
      <li><a href="#" data-action="Bold"><i class="fa fa-bold"></i></a>
      </li>
      <li><a href="#" data-action="Italic"><i class="fa fa-italic"></i></a>
      </li>
      <li><a href="#" class=""><i class="fa fa-link"></i></a>
      </li>
    </ul>
    <div class="body">
      <div>
        <div class="top">
          <span>{{ currentTime }}</span>
        </div>
        <div class="content">
          <div class="quick-note-editor full-width full-height js-input" contenteditable="true"></div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>

  import moment from 'moment';
  
  export default {
    name: "NoteEditor",
    data: () => ({
      currentTime: new Date()
    }),
    created() {
      this.regenTime();
    },
    methods: {
      regenTime() {
        const self = this;
        setTimeout(() => {
          self.currentTime = moment(new Date()).format('DD.MM.YYYY HH:mm');
          self.regenTime();
        }, 1000);
      }
    }
  }
</script>


// WEBPACK FOOTER //
// note_editor.vue?68b1f86a